import { AbstractComponent } from '@/utils/sections/abstract-component';
import { register } from '@/utils/sections/registration';
import Swiper, { Navigation, Autoplay } from 'swiper';
import { isNumber } from '../utils/numbers';

const AUTOPLAY_DURATION = 5000;

export class Gallery extends AbstractComponent {
  init() {
    this.initSwiper();
    // this.removeAdjacentMargins();
  }

  removeAdjacentMargins() {
    const isFullWidth = this.el.classList.contains('is-fullwidth');

    if(isFullWidth) {
      const parentSection = this.el.closest('.section');

      if(parentSection) {
        parentSection.style.marginTop = '0';
        parentSection.style.marginBottom = '0';

        // find prev section and remove its bottom margin
        const prevContainer = parentSection.previousElementSibling;
        if(prevContainer && prevContainer?.classList?.contains('section')) {
          prevContainer.style.marginBottom = '0';
        }

        // find next section and remove its top margin
        const nextContainer = parentSection.nextElementSibling;
        if(nextContainer && nextContainer?.classList?.contains('section')) {
          nextContainer.style.marginTop = '0';
        }
      }
    }
  }

  initSwiper() {
    const swiperContainer = this.el.querySelector('[data-swiper]');
    if (!swiperContainer) return;

    const itemsQty = isNumber(swiperContainer?.dataset?.swiperItemsQty) ? parseInt(swiperContainer?.dataset?.swiperItemsQty) : 0;
    const enabled = itemsQty > 1;

    this.swiper = new Swiper(swiperContainer, {
      enabled,
      modules: [Navigation, Autoplay],
      autoplay: { delay: AUTOPLAY_DURATION },
      loop: true,
      slidesPerView: 1,
      spaceBetween: 25,
      navigation: {
        nextEl: this.el.querySelector('.swiper-button-next'),
        prevEl: this.el.querySelector('.swiper-button-prev'),
      },
    });
  }

  onUnload() {
    this.swiper?.destroy();
  }
}

register('gallery', Gallery);
